//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";

export default {
  data() {
    return {
      username: "",
      password: "",
      password_repeat: "",
      name: "",
      lastname: "",
      email: "",
      token: "",
      msg: "",
    };
  },

  created() {
    if ("" + this.$route.query.token != "undefined") {
      this.token = this.$route.query.token;
      this.verify();
      console.log("VERIFY REGISTER TOKEN");
    }
  },

  methods: {
    ...mapActions(["signUp", "verifyToken"]),
    async signUp() {
      try {
        const credentials = {
          username: this.username,
          password: this.password,
          password_repeat: this.password_repeat,
          firstname: this.name,
          lastname: this.lastname,
          email: this.email,
        };

        const response = await this.signUp(credentials);
        this.msg = response.msg;
      } catch (error) {
        this.msg = error.response.data.msg;
      }
    },
    async verify() {
      try {
        const tokenInfo = {
          token: this.token,
        };

        const response = await this.verifyToken(tokenInfo);
        this.msg = response.msg;
      } catch (error) {
        this.msg = error.response.data.msg;
      }
    },
  },
};
